import { atom } from 'nanostores';

/** Whether the left hover sidebar is currently open. */
export const $leftSidebarOpen = atom<boolean>(false);

export function openLeftSidebar(): void {
  $leftSidebarOpen.set(true);
}

export function closeLeftSidebar(): void {
  $leftSidebarOpen.set(false);
}

export function toggleLeftSidebar(): void {
  $leftSidebarOpen.set(!$leftSidebarOpen.get());
}
